import { render, staticRenderFns } from "./LoginAccount.vue?vue&type=template&id=d59ac884&scoped=true&"
import script from "./LoginAccount.vue?vue&type=script&lang=js&"
export * from "./LoginAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d59ac884",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d59ac884')) {
      api.createRecord('d59ac884', component.options)
    } else {
      api.reload('d59ac884', component.options)
    }
    module.hot.accept("./LoginAccount.vue?vue&type=template&id=d59ac884&scoped=true&", function () {
      api.rerender('d59ac884', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/LoginAccount.vue"
export default component.exports